/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Form Lock.
 * Prevents form from being toggled when another is active.
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 * @deprecated Not used in v2.0
 */

class FormLock {
	constructor() {
		this.self = this;
	}

	init() {
		console.log("FormLock.js: init()");

		// Lock existing form
		this.lockForm();

		// Attach change listeners to relevant fields
		document.querySelectorAll("[data-lock='true']").forEach((el) => {
			el.addEventListener("change", () => this.checkForm());
		});
	}

	checkForm() {
		const c = this.validateForm();

		if (c) {
			this.unlockForm();
		} else {
			this.lockForm();
		}
		console.log("Form ready?: " + c);
	}

	lockForm() {
		// Add class to all submit buttons
		document.querySelectorAll("input[type='submit']").forEach((el) => {
			el.classList.add("locked");
		});

		// Prevent submission of locked forms
		document.querySelectorAll("form.form-locked").forEach((form) => {
			form.addEventListener("submit", this.preventSubmit, true);
		});
	}

	unlockForm() {
		// Remove class from all submit buttons
		document.querySelectorAll("input[type='submit']").forEach((el) => {
			el.classList.remove("locked");
		});

		// Remove submit prevention
		document.querySelectorAll("form.form-locked").forEach((form) => {
			form.removeEventListener("submit", this.preventSubmit, true);
		});
	}

	preventSubmit(e) {
		e.preventDefault();
	}

	validateForm() {
		let isValid = true;

		document.querySelectorAll("input[data-lock='true']").forEach((input) => {
			if (input.offsetParent !== null && input.value === "") {
				isValid = false;
			}
		});

		document.querySelectorAll("select[data-lock='true']").forEach((select) => {
			if (select.offsetParent !== null && select.value === "-1") {
				isValid = false;
			}
		});

		return isValid;
	}
}

export default new FormLock();
